"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const FormUtil_1 = require("../../Components/Form/FormUtil");
const ResponseError_1 = require("../../Components/Http/Error/ResponseError");
const HttpClient_1 = require("../../Components/Http/HttpClient");
const Druid_1 = require("../../Druid");
const TypeGuard_1 = require("../../Types/TypeGuard");
const RejectError_1 = require("../../DOM/Error/RejectError");
class FormSubmitter {
    constructor(form, options) {
        this.form = form;
        this.options = options;
    }
    submit(url, data) {
        var _a, _b;
        if (((_a = this.options) === null || _a === void 0 ? void 0 : _a.validateForm) === true && FormUtil_1.default.reportValidity(this.form, this.options) === false) {
            return Promise.reject();
        }
        let formData = this.form.getFormData((_b = this.options) === null || _b === void 0 ? void 0 : _b.role, this.options);
        if (data !== undefined) {
            formData = { ...data, ...formData };
        }
        this.disableForm(true);
        return HttpClient_1.default.post(url, formData)
            .then(response => response.json())
            .then((json) => {
            this.disableForm(false);
            return json;
        })
            .catch((response) => {
            this.disableForm(false);
            // if response is of type ResponseError, just get the response
            response = response instanceof ResponseError_1.default ? response.response : response;
            if (TypeGuard_1.default.isResponse(response) === false) {
                return Promise.reject(new Error());
            }
            // if response, handle it as NotifyFactory::formError response
            return response.json()
                .then((json) => {
                FormUtil_1.default.setFormErrors(this.form, json);
                return Promise.reject(new RejectError_1.default('', json));
            });
        })
            .finally(() => {
            var _a, _b;
            if ((_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.clearForm) !== null && _b !== void 0 ? _b : true) {
                FormUtil_1.default.resetForm(this.form, Druid_1.default.configuration().form.fileInputs.join(','));
            }
        });
    }
    disableForm(disable) {
        var _a;
        if (((_a = this.options) === null || _a === void 0 ? void 0 : _a.disableForm) === true) {
            FormUtil_1.default.disableForm(this.form, disable, { selector: 'button, input, textarea, select,.' + Druid_1.default.configuration().form.className });
        }
    }
}
exports.default = FormSubmitter;
//# sourceMappingURL=FormSubmitter.js.map